'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { useAuthStore } from '@/store/auth.store';

/** Re-validates session against the HttpOnly cookie after page refresh. */
export function AuthHydrator() {
  const pathname = usePathname();
  const hydrateSession = useAuthStore((s) => s.hydrateSession);

  useEffect(() => {
    if (!pathname?.startsWith('/admin')) return;
    void hydrateSession();
  }, [hydrateSession, pathname]);

  return null;
}
